module.exports = __webpack_public_path__ + "media/images/writer/reservation/banner-e3eba4c9ca18318ce5635e0e6830ae87.png";